import { useEffect, useRef, useState } from "react";
import { getCustomersAsync } from "src/redux/actions/customerAction";
import { useAppDispatch } from "src/redux/storeHooks";

const CustomerDropdown = ({ selectedCustomers, onSelect, onAllSelect, isAllSelect, customerView = false, }) => {
  const dispatch = useAppDispatch();
  const dropdownRef = useRef<HTMLDivElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);

  const [customers, setCustomers] = useState<any>([]);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const delay = setTimeout(() => {
      setDebouncedSearch(search);
    }, 300);
    return () => clearTimeout(delay);
  }, [search]);

  const fetchCustomers = async (searchVal = "", pageNum = 1) => {
    setLoading(true);
    const result = await dispatch(
      getCustomersAsync({
        search: searchVal,
        page_num: pageNum,
        page_limit: 25,
        order_by: "-id",
        user_type: "USER",
        from_date: "",
        to_date: "",
        sync_from_date: "",
        sync_to_date: "",
        source: "",
        ...(customerView ? { customer_view: true } : {}),
      })
    );

    const payload = result.payload;
    const newData = Array.isArray(payload?.data?.data)
      ? payload.data.data
      : Array.isArray(payload?.data)
      ? payload.data
      : Array.isArray(payload)
      ? payload
      : [];

    if (pageNum === 1) {
      setCustomers(newData);
    } else {
      setCustomers((prev) => [...prev, ...newData]);
    }

    setHasMore(newData.length === 25);
    setLoading(false);
  };

  useEffect(() => {
    fetchCustomers(debouncedSearch, page);
  }, [debouncedSearch, page]);

  const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const isBottom =
      e.currentTarget.scrollHeight - e.currentTarget.scrollTop <=
      e.currentTarget.clientHeight + 10;

    if (isBottom && hasMore && !loading) {
      setPage((prev) => prev + 1);
    }
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
    setPage(1);
  };

  return (
    <div className="w-100" ref={dropdownRef}>
      <style>
        {`
          .customer-checkbox {
            width: 20px;
            height: 20px;
          }
        `}
      </style>
      <input
        ref={inputRef}
        type="text"
        className="form-control"
        value={search}
        onChange={handleSearchChange}
        placeholder={isAllSelect? `All Selected`:`Total Selected Customer: ${selectedCustomers.length}`}
      />

      <div
        className="border rounded mt-2 bg-white shadow-sm w-100"
        style={{ maxHeight: "240px", overflowY: "auto" }}
        onScroll={handleScroll}
      >
        {customers.length === 0 && !loading && (
          <div className="p-2 text-muted">No customers found</div>
        )}

        <div
          className="px-3 py-2 border-bottom d-flex align-items-start"
          style={{ cursor: "pointer" }}
          onClick={() => onAllSelect(!isAllSelect)}
        >
          <input
            type="checkbox"
            checked={isAllSelect}
            readOnly
            className="me-2 mt-1 customer-checkbox"
          />
          <div>
            <div className="fw-bold">Select All</div>
          </div>
        </div>
        {customers.map((user) => {
          const isSelected = selectedCustomers.includes(user.id);
          return (
            <div
              key={user.id}
              className="px-3 py-2 border-bottom d-flex align-items-start"
              style={{ cursor: "pointer" }}
              onClick={() => onSelect(user.id)}
            >
              <input
                type="checkbox"
                checked={isAllSelect || isSelected}
                readOnly
                className="me-2 mt-1 customer-checkbox"
              />
              <div>
                <div className="fw-bold">{user.name}</div>
                <div className="text-muted" style={{ fontSize: "12px" }}>
                  {user.email}
                </div>
              </div>
            </div>
          );
        })}

        {loading && (
          <div className="p-2 text-center text-muted">Loading...</div>
        )}
      </div>
    </div>
  );
};

export default CustomerDropdown;
